import { Box } from '@mui/material';
import { UseQueryResult } from '@tanstack/react-query';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  ArcElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

import { DashCampaignsModelView } from '~/types';

import { DonutChart } from './DonutChart';
import { LineChart } from './LineChart';
import { ProgressCampaign } from './ProgressCampaign';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface DashboardChartsProps {
  getDashboardQuery: UseQueryResult<DashCampaignsModelView>;
  isLoading: boolean;
}

export function DashboardCharts({
  getDashboardQuery,
  isLoading,
}: DashboardChartsProps) {
  const isLoadingOrError =
    isLoading || getDashboardQuery.isError || !getDashboardQuery.data;

  const defaultData: DashCampaignsModelView = {
    totalInvestment: '0',
    totalCampaign: '0',
    total: '0',
    bestCampaigns: [],
    segments: {
      totalInvestment: '0',
      items: [],
    },
    newCampaign: {
      days: [],
    },
    campaignProgress: [],
    impressions: '0',
    clicks: '0',
    ctr: '0',
    cpm: '0',
    cpi: '0',
    cpc: '0',
  };

  const dashboardData = getDashboardQuery.data ?? defaultData;

  return (
    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
      <DonutChart data={dashboardData} isLoading={isLoadingOrError} />
      <LineChart data={dashboardData} isLoading={isLoadingOrError} />
      <ProgressCampaign data={dashboardData} isLoading={isLoadingOrError} />
    </Box>
  );
}
